/** Logo mark only — original bright green */
export const LOGO_GREEN = "#00FFA3";

/** Primary UI accent — darker green for trust/security */
export const BRAND_GREEN = "#00BF0D";
export const BRAND_GREEN_HOVER = "#00D414";
